import { Container, Paper, Typography } from "@mui/material";
import parse from "html-react-parser";
import Footer from "../components/footer";
import Header from "../components/header";
import content from "../docs/privacy_v1.html";

function PrivacyPolicy() {
  return (
    <>
      <Header />
      <Container className="consent" maxWidth="md">
        <Typography variant="h2" textAlign="center" marginY={3}>
          Privacy Policy
        </Typography>
        <Paper sx={{ padding: 2, marginBottom: 4, borderRadius: 2 }}>
          <Typography component="div" variant="body1">{parse(content)}</Typography>
        </Paper>
      </Container>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
